'use client';

import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

export function Loading({ isLoading }: { isLoading: boolean }) {
  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        padding={10}
        bgcolor="white"
        borderRadius={3}
      >
        <CircularProgress />
        <Typography>loading...</Typography>
      </Box>
    </Backdrop>
  );
}
